import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import type { ChangelogEntry } from "@somewear/api";

import { changelogActions } from "./changelog.actions";
import { ChangelogAsyncStatus } from "./changelog.model";
import type { ChangelogState } from "./changelog.state";

const adapter = createEntityAdapter<ChangelogEntry.AsObject>({
	selectId: (changelog) => changelog.pageId,
});

export const { selectAll: selectAllChangelogEntries } = adapter.getSelectors(
	(state: ChangelogState) => state.changelog,
);

const initialState = adapter.getInitialState({
	status: ChangelogAsyncStatus.INITIAL,
});

export const changelogSlice = createSlice({
	name: "changelog",
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(changelogActions.getChangelog.pending, (state) => {
			state.status = ChangelogAsyncStatus.LOADING;
		});
		builder.addCase(changelogActions.getChangelog.rejected, (state) => {
			state.status = ChangelogAsyncStatus.IDLE;
		});
		builder.addCase(changelogActions.getChangelog.fulfilled, (state, action) => {
			adapter.upsertMany(state, action.payload.data.entriesList);
			state.status = ChangelogAsyncStatus.IDLE;
		});
	},
});
